import React from 'react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  DragOverlay,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import { SortableContext, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import _ from 'lodash';
import { UNIT } from '../../constants';
import { checkAccess } from '../../utils/admins';

const SortableItem = props => {
  const { id } = props;
  const sortable = useSortable({ id });
  const { attributes, listeners, setNodeRef, transform, isDragging, transition } = sortable;
  const handleProps = {
    ...attributes,
    ...listeners
  };
  return (
    <div
      ref={setNodeRef}
      style={{
        transform: checkAccess('features', 'productAndOption') && CSS.Transform.toString(transform),
        transition: checkAccess('features', 'productAndOption') && transition,
        opacity: isDragging && 0.5
      }}
      {...isDragging}
      {...props}
    >
      {props.renderItem(handleProps)}
    </div>
  );
};

const SortableList = props => {
  const { list, activeId } = props;
  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      distance: UNIT * 0.625
    }
  });

  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: {
      delay: 250,
      tolerance: 5
    }
  });
  const keyboardSensor = useSensor(KeyboardSensor);

  const sensors = useSensors(mouseSensor, touchSensor, keyboardSensor);

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={e => checkAccess('features', 'productAndOption') && props.handleDragStart(e)}
      onDragEnd={e => checkAccess('features', 'productAndOption') && props.handleDragEnd(e)}
      onDragMove={e => checkAccess('features', 'productAndOption') && props.handleDragMove(e)}
    >
      <SortableContext items={_.keys(list)} strategy={props.strategy}>
        {list &&
          _.map(list, (listItem, index) => {
            const { key = '' } = listItem;
            return (
              <SortableItem
                key={key}
                id={index}
                index={index}
                renderItem={handleProps => props.renderItem(index, handleProps)}
              />
            );
          })}
      </SortableContext>

      {checkAccess('features', 'productAndOption') && (
        <DragOverlay> {activeId ? props.renderItem(activeId) : null}</DragOverlay>
      )}
    </DndContext>
  );
};
export default SortableList;
